import { computed, Injectable, signal } from '@angular/core';

interface Dashboard {
    enrolledCourses: any[];
    dueCourses: any[];
    totalAssignedCourses: number;
    totalAssignedLearningPaths: number;
    totalEnrolledCourses: number;
    totalEnrolledUsers: number;
    weeklyGoal: number;
}

export interface DashboardState {
    dashboard: Dashboard | null;
    loading: boolean;
    error: string | null;
}

@Injectable({ providedIn: 'root' })
export class DashboardStore {
    private readonly state = signal<DashboardState>({
        dashboard: null,
        loading: false,
        error: null,
    });

    readonly dashboard$ = computed(() => this.state().dashboard);
    readonly loading$ = computed(() => this.state().loading);
    readonly error$ = computed(() => this.state().error);

    setLoading(loading: boolean): void {
        this.state.update((state) => ({ ...state, loading }));
    }

    setError(error: string | null): void {
        this.state.update((state) => ({ ...state, error }));
    }

    setDashboard(dashboard: Dashboard): void {
        this.state.update((state) => ({ ...state, dashboard, loading: false }));
    }

    reset(): void {
        this.state.set({
            dashboard: null,
            loading: false,
            error: null,
        });
    }
}
